// packages/pixai-app/src/routes/_app.mio2.gem-pack._index.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_app.mio2.gem-pack._index')

export const handle = {
  name: 'mio2/gem-pack',
  hideMembershipBanner: true,
  showCreditPill: true,
}

export default dynamic(getClientModule, { ssr: false })
